/* global Search, searchWebinarsDataRaw, searchWebinarsData */
import loadFbjsScript from "../../_global/js/fbjsLoader.js";
// Loading more in archived webinars is custom.
if (document.querySelector(".fbjs-search--webinars-events")) {
    window.x = []; // for debug funnelback data
    window.searchWebinarsDataRaw = [];
    window.searchWebinarsData = {
        aditionalInfo: {
            resetData: 1,
            displayArchived: 18,
        },

        webinars: {},
    };
}
let hasActiveFilters;
window.hasResults = false;
const sortData = () => {
    window.searchWebinarsDataRaw.length ? window.hasResults = true : window.hasResults = false;
    let currentDate = new Date();
    var date = currentDate.getTime();

    searchWebinarsData.webinars.upcoming = searchWebinarsDataRaw.filter(
        (el) => {

            if (el.eventEndDate && el.eventStartDate) {
                // console.log("el", el);
                const startYear =
                    el.eventStartDate?.[0]?.length >= 4
                        ? el.eventStartDate[0].slice(0, 4)
                        : "0000";
                const startMonth =
                    el.eventStartDate?.[0]?.length >= 6
                        ? el.eventStartDate[0].slice(4, 6)
                        : "00";
                const startDay =
                    el.eventStartDate?.[0]?.length >= 8
                        ? el.eventStartDate[0].slice(6, 8)
                        : "00";
                const startHr =
                    el.eventStartDate?.[0]?.length >= 11
                        ? el.eventStartDate[0].slice(9, 11)
                        : "00";

                const year =
                    el.eventEndDate?.[0]?.length >= 4
                        ? el.eventEndDate[0].slice(0, 4)
                        : "0000";
                const month =
                    el.eventEndDate?.[0]?.length >= 6
                        ? el.eventEndDate[0].slice(4, 6)
                        : "00";
                const day =
                    el.eventEndDate?.[0]?.length >= 8
                        ? el.eventEndDate[0].slice(6, 8)
                        : "00";
                const hour =
                    el.eventEndDate?.[0]?.length >= 11
                        ? el.eventEndDate[0].slice(9, 11)
                        : "00";

                const eventSortedDate = `${year}-${month}-${day}${hour ? ' ' + hour + ':00:00' : ''}`;
                const eventStartDateString = `${startYear}-${startMonth}-${startDay}${startHr ? " " + startHr + ":00:00" : ""
                    }`;
                const eventStartDateObj = new Date(eventStartDateString);
                const eventDateObj = new Date(eventSortedDate);
                const eventDate = eventDateObj.getTime();
                const eventStartDate = eventStartDateObj.getTime();
                if (eventStartDate < eventDate) {
                    return eventDate >= date;
                } else {
                    return eventStartDate >= date;
                }

            }

        }
    );
    let sortedListAsset = searchWebinarsData.webinars.upcoming.sort(((a, b) => {
        return a.eventStartDate.slice(0, 8) - b.eventStartDate.slice(0, 8);
    }));
    searchWebinarsData.webinars.upcoming = sortedListAsset;
    searchWebinarsData.webinars.archived = searchWebinarsDataRaw.filter((el) => {
        const isUpcoming = searchWebinarsData.webinars.upcoming.includes(el);

        if (el.eventEndDate && !isUpcoming) {
            // Ensure eventEndDate is treated as a string
            const cleanDateStr = String(el.eventEndDate).replace(/\D/g, '').slice(0, 8);
            const year = cleanDateStr.slice(0, 4);
            const month = cleanDateStr.slice(4, 6);
            const day = cleanDateStr.slice(6, 8);

            // Parse the date and check if it's valid
            const eventDateObj = new Date(`${year}-${month}-${day}`);
            if (!isNaN(eventDateObj.getTime())) { // Check if the date is valid
                const eventDate = eventDateObj.getTime();
                return eventDate < date && el.pageType === "Webinar";
            } else {
                console.error(`Invalid date format after cleaning for eventEndDate: ${el.eventEndDate}`);
            }
        }

        return false;
    });




};

const buildHtml = async () => {
    let output = '<div class="insights-webinars-events-listing__wrapper">';
    const signleElementTemplate = (
        eventUrl,
        title,
        eventImage,
        pageType,
        itemSubheading,
        eventStartDate,
        // webinarSubheading,
        // eventSubheading,
        eventLocation,
        eventButtonText,
        eventExternalUrl,
        content,
        keyMarketEnergy,
        eventYear,
        webinarTime,
        keywords,
        dateWrapper,
        eventMonth = null,
        description,
        currentDate = new Date()
    ) => `<div class="col-4 col-md-6 col-sm-12 col-lg-4"><a href="${
        eventExternalUrl
            ? eventExternalUrl
            : `https://wood-search.funnelback.squiz.cloud${eventUrl}`
    }" class="webinars-wrapper--link">
    <div class="webinars-wrapper ${pageType !== "Webinar" ? "event-wrapper" : ""
        }">
        <article class="cards__card row no-gutters flex-column">
            ${eventMonth !== null
            ? `<div class="cards__flag-wrapper">
                            <div class="cards__flag-upcoming">
                                <span> ${eventMonth}</span> ${dateWrapper}
                            </div>
                        </div>`
            : ``
        }
            <div class="cards__image-wrapper">
                <div class="cards__image" style="
                        background-image: url(${eventImage});
                    "></div>
            </div>
            <div class="cards__content no-gutters flex-column">
                <div class="cards__flags">
                ${pageType
            ? `<div class="cards__flag-webinar">${pageType}</div>`
            : ``
        }
                ${pageType === "Webinar"
            ? ` <div class="cards__flag-time">${webinarTime ? webinarTime + "min" : "60min"
            }</div>`
            : webinarTime
                ? `<div class="cards__flag-time">
                ${webinarTime}
            </div>`
                : ""
        }
                ${pageType == "Webinar" &&
            new Date(eventStartDate).getTime() < currentDate.getTime()
            ? `<div class="cards__flag-time">${eventYear}</div>`
            : ``
        }
                ${pageType == "Webinar"
            ? `<div class="cards__flag-type">Video</div>`
            : ``
        }
                ${eventLocation
            ? `<div class="cards__flag-time">${eventLocation}</div>`
            : ``
        }
                </div>
                <div>
                <p class="category">${pageType}</p>
                    <p class="title truncate-lines-2"">${title}
                    </p>
                </div>
                 ${itemSubheading ? itemSubheading : ""}
                ${description
            ? `<p class="description truncate-lines-2">${description}</p>`
            : ``
        }
                ${keywords ? `<div class="tags">${keywords}</div>` : ``}
                </div>
                <div class="cards__links">
                    <p class="primary-link" >
                        ${pageType == "Webinar"
            ? eventButtonText || "Watch now"
            : eventButtonText || "Register now"
        }
                    </p>
                </div>
        </article>
    </div>
</a></div>`;

    /**
     *
     * @param {[]} array array with items
     * @param {string} heading
     * @returns  html
     */

    await sortData();

    /**
     * display data
     */
    if (searchWebinarsData?.webinars?.upcoming?.length) {
        output += `<h5 class="webinars-header">Upcoming events</h5>
            <div class="cards cards-story upcoming"><div class="cards__wrapper results">`;
        searchWebinarsData.webinars.upcoming.map((el) => {
            output += signleElementTemplate(
                el.eventUrl,
                el.title,
                el.eventImage,
                el.pageType,
                el.itemSubheading,
                el.eventStartDate,
                // el.webinarSubheading,
                // el.eventSubheading,
                el.eventLocation,
                el.eventButtonText,
                el.eventExternalUrl,
                el.content,
                el.keyMarketEnergy,
                el.eventYear,
                el.webinarTime,
                el.keywords,
                el.dateWrapper,
                el.eventMonth,
                el.description
            );
        });

        output += `</div></div>`;
    } else if (window.hasResults) {
        let facetCount =
            document.querySelector(".active-facets").childElementCount;
        let url = window.location.href;
        if (facetCount) {
            output += `
        <h5 class="webinars-header">Upcoming events</h5>
        <p>There are no upcoming events matching your filter criteria.</p>`;
        } else if (url.includes("?")) {
            output += `
        <h5 class="webinars-header">Upcoming events</h5>
        <p>There are no upcoming events at this time.</p>`;
        }
    } else {
        output += `<p>Loading...</p>`;
    }
    console.log(searchWebinarsData)
    if (searchWebinarsData.webinars.archived.length) {
        console.log('here')
        output += `<h5 class="webinars-header" id="webinars">Webinar library</h5><div class="cards cards-story webinars-library"><div class="cards__wrapper results">`;
        searchWebinarsData.webinars.archived
            .slice(0, searchWebinarsData.aditionalInfo.displayArchived)
            .map((el) => {
                output += signleElementTemplate(
                    el.eventUrl,
                    el.title,
                    el.eventImage,
                    el.pageType,
                    el.itemSubheading,
                    el.eventStartDate,
                    el.eventLocation,
                    el.eventButtonText,
                    el.eventExternalUrl,
                    el.content,
                    el.keyMarketEnergy,
                    el.eventYear,
                    el.webinarTime,
                    el.keywords,
                    el.dateWrapper,
                    el.eventMonth,
                    el.description,

                );
            });

        output += `</div></div>`;
    }

    if (
        searchWebinarsData.aditionalInfo.displayArchived <
        searchWebinarsData.webinars.archived.length
    ) {
        output += `<div class="landing-page__button-wrapper"><button id="load-more-archived-events" type="button" title="Load more results" class="btn btn--secondary">Load more</button></div>`;
    }

    output += "</div>";

    //removing old output after raload data
    var contntWrapper = document.querySelector(
        "insights-webinars-events-listing__wrapper"
    );
    if (contntWrapper) {
        contntWrapper.parentNode.removeChild(contntWrapper);
    }

    //displaing output on front
    document.querySelector(".results-wrapper").innerHTML = output;

    // console.log(output);

    const loadMoreButton = document.getElementById("load-more-archived-events");
    if (loadMoreButton) {
        loadMoreButton.addEventListener("click", () => {
            searchWebinarsData.aditionalInfo.displayArchived += 18;
            buildHtml();
        });
    }
};
const initWebinarsEventsSearch = async () => {
    if (!document.querySelector(".fbjs-search--webinars-events")) return;

    try {
        await loadFbjsScript();
        window.webinarsEvents = new Search.default({
        url: "https://wood-search.funnelback.squiz.cloud/s/search.json",
        collections: ["wood~sp-push-data"],
        additionalFBparams: {
            profile: "_default",
            gscope1: "webinarsAndEvents", //we cant use it
            //// 'f.pageType|pageType': 'event+-+virtual+event',
            //  'f.pageType|pageType': 'event+-+physical+event',
            //  'f.pageType%7CpageType': 'event+-+webinar'
        },
        onFiltersUpdate: () => {
            buildHtml();
            searchWebinarsData.aditionalInfo.resetData = 1;
            const activeFilters = window.webinarsEvents?.search?.activeFacets;
            for (const entry in activeFilters) {
                if (activeFilters[entry].value && activeFilters[entry].value.length > 0) {
                    hasActiveFilters = true;
                    return hasActiveFilters;
                }
            }
        },
        beforeSearch: () => {
            if (searchWebinarsData.aditionalInfo.resetData) {
                searchWebinarsDataRaw = [];
                searchWebinarsData.webinars = {
                    upcoming: [],
                    archived: [],
                };
                searchWebinarsData.aditionalInfo.resetData = 0;
                searchWebinarsData.aditionalInfo.displayArchived = 18;
            }
        },
        results: {
            numRanks: 300,
        },
        sort: {
            type: "dmetad",
        },
        activeFacets: {
            target: ".active-facets",
            // ... some other configuration fields
        },
        activeFacetsOnStart: {
            "f.Geography|categorisationGeography": [],
            "f.Sectors|categorisationSectors": [],
            "f.Solutions|categorisationSolutions": [],

            "f.pageType|pageType": [
                //         "expertise - software",
                //         "expertise - sme profile",
                //         "expertise - product",
                //         "expertise - expertise",
                //         "key market"
            ],
            "f.keyMarketEnergy|keyMarketEnergy": [],
            "f.keyMarketEnvironment|keyMarketEnvironment": [],
            "f.geographies|geographies": [],
        },

        pagination: {
            loadMore: false,
            arrows: false,
            arrowsOnEdgePages: false,
            dots: false,
            edgePages: false,
            pages: 0,
        },

        templates: {
            activeFacet: (name, param) => {
                const changeName = name
                    .replace(/_ampersand_/gi, "&")
                    .replace(/_comma_/gi, ",");
                return `
                  <span param="${param}" name="${name}">
                    ${changeName}
                  </span>
                `;
            },
            articleTemplate: (fields) => {
                let pageType = fields.listMetadata.pageType[0]
                    ? fields.listMetadata.pageType[0].replace(/\w*\s-\s/gm, "")
                    : "";

                // 2017-08-10 -> 10 Aug 2017
                const changeDate = (dateToChange) => {
                    const splitedDate = dateToChange.split("-");
                    return `${splitedDate[2]}`;
                };
                const changeTwoDates = (firstDate, secondDate) => {
                    const splitFirstDate = firstDate.split("-"),
                        splitSecondDate = secondDate.split("-");
                    return `${splitFirstDate[2]} - ${splitSecondDate[2]}`;
                };
                const eventEndDate = fields.listMetadata.ewDateEnd;
                const eventStartDate = fields.listMetadata.ewDateStart;
                const eventEndDateCorrect = `${eventEndDate?.[0].slice(
                    0,
                    4
                )}-${eventEndDate?.[0].slice(4, 6)}-${eventEndDate?.[0].slice(6, 8)}`;
                const eventStartDateCorrect = `${eventStartDate?.[0].slice(
                    0,
                    4
                )}-${eventStartDate?.[0].slice(4, 6)}-${eventStartDate?.[0].slice(
                    6,
                    8
                )}`;
                const eventMonth = fields.listMetadata.eventMonth;
                const eventImage = fields.listMetadata.image;
                const title = fields.listMetadata.t;
                const eventLocation = fields.listMetadata.ewLocation;
                const eventButtonText =
                    fields.listMetadata.ewCTAAlternativeText;
                const eventUrl = fields.clickTrackingUrl;
                const eventExternalUrl = fields.listMetadata.ewCTALinkExternal;
                const eventYear = fields.listMetadata.d.slice(0, 4);
                const webinarTime = fields.listMetadata.ewDuration;
                const keywords =
                    Array.isArray(fields.listMetadata.ewTopicTags) &&
                    fields.listMetadata.ewTopicTags.length > 0
                        ? fields.listMetadata.ewTopicTags[0].replaceAll(
                              ";",
                              " | "
                          )
                        : "";
                const itemSubheading = fields.listMetadata.ewSubtitle
                    ? `<p class="description subheading truncate-lines-2">${fields.listMetadata.ewSubtitle}</p>`
                    : ``;
                const content = fields.listMetadata.content;
                const keyMarketEnergy = fields.listMetadata.keyMarketEnergy;
                const description = fields.listMetadata.ewDescription;
                let dateWrapper = "";

                if (
                    eventStartDateCorrect ===
                    eventEndDateCorrect ||
                    eventEndDateCorrect === undefined || eventEndDateCorrect === '2022-01-01'
                ) {
                    dateWrapper =
                        eventStartDateCorrect &&
                        changeDate(eventStartDateCorrect);
                } else {
                    dateWrapper = `${changeTwoDates(
                        eventStartDateCorrect,
                        eventEndDateCorrect
                    )}`;
                }
                searchWebinarsDataRaw.push({
                    title: title,
                    pageType: pageType,
                    eventUrl: eventUrl,
                    eventImage: eventImage,
                    itemSubheading: itemSubheading,
                    // webinarSubheading: webinarSubheading,
                    // eventSubheading: eventSubheading,
                    eventLocation: eventLocation,
                    eventStartDate: eventStartDate,
                    eventEndDate: eventEndDate,
                    eventButtonText: eventButtonText,
                    eventExternalUrl: eventExternalUrl,
                    content: content,
                    keyMarketEnergy: keyMarketEnergy,
                    eventYear: eventYear,
                    webinarTime: webinarTime,
                    keywords: keywords,
                    dateWrapper: dateWrapper,
                    eventMonth: eventMonth,
                    description: description,
                });

                return ``;
            },
            /**
             * @param fields
             * @param resultsSummary
             * @param h
             * @returns {string}
             */
            informationTemplate: () => {
                buildHtml();
                return ``;
            },
            formTemplate: (search, query, inputId) => {
                query == "!nullsearch" ? (query = "") : null;
                return `
                <div class="search-field">
                    <form class="search__form" role="search" action="/search" method="get">
                        <label for="${inputId}" class="sr-only">Search site</label>
                        <input
                            id="${inputId}"
                            type="text"
                            class="search__form-input search-custom"
                            placeholder="Search webinars & events"
                            autocomplete="off"
                            role="searchbox"
                            aria-label="Search"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            maxlength="1000"
                            value="${query}">
                        <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                            <i class="search__submit-icon" aria-hidden="true"></i>
                            <span class="sr-only">Do search</span>
                        </button>
                        <div class="fb-search-wrapper"></div>
                    </form>
                </div>
                `;
            },
            /**
             * @param number
             * @param startrank
             * @returns {string}
             */
            paginationNumberTemplate: () => {
                return ""; //<li class="hidden" data-startrank=${startrank} tabindex="0" >${number}</li>
            },
            /**
             * @param number
             * @returns {string}
             */
            activePaginationNumberTemplate: () => {
                return ""; //<li class="search__active-page hidden">${number}</li>
            },
            /**
             * @param pages
             * @returns {string}
             */
            paginationTemplate: (pages) => {
                return `<div class="search__pagination">${pages}</div>`;
            },
            /**
             * @param fields
             * @returns {string}
             */
            loadMoreTemplate: () => {
                return '<div class="landing-page__button-wrapper"><button id="search-loadmore" type="button" title="Load more results" class="btn btn--secondary">Load more</button></div>';
            },

            facetCheckbox: ({ categories, singleChoice }, activeFacets, h) => {
                let list = "";
                list +=
                    '<li class="search__facet-item search__facet-item--all"></li>';

                categories[0].values.forEach((item) => {
                    if (item.label !== "other") {
                        list += `<li class="search__facet-item">
                                <label class="search__facet-label">
                                    <input
                                    class="search__facet-input"
                                    type="checkbox"
                                    ${item.checked}
                                    value="${item.data}"
                                    name="${item.label}"
                                    data-fparam="${h.queryStringParamName}"
                                    data-singlechoice="${singleChoice}"
                                    />
                                    <span class="search__facet-span">${item.label}</span>
                                </label>
                                </li>`;
                    }
                });

                return `<div class="checkbox-facet">
                        <ul class="search__facets">
                        ${list}
                        </ul>
                    </div>`;
            },
            /**
             * @param query
             * @param spell
             * @returns {string}
             */
            noResults: () => {
                if (hasActiveFilters) {
                    return `<div>There are no results matching your filter criteria</div>`;
                } else {
                    return `<div>We're sorry, we couldn't find anything matching</div>`;
                }
            },
        },
    });

        window.webinarsEvents.init();
        const observerFunc = () => {
            const articles = document.querySelectorAll("article");
            articles.forEach((article) => {
                article.addEventListener("pointerenter", (e) => {
                    e.target.classList.add("has-hover");
                });
                article.addEventListener("pointerleave", (e) => {
                    e.target.classList.remove("has-hover");
                });
            });
        };
        const observerTarget = document.querySelector(
            ".fbjs-search--webinars-events"
        );
        if (observerTarget) {
            const observer = new MutationObserver(observerFunc);
            const observerConfig = {
                subtree: true,
                childList: true,
            };
            observer.observe(observerTarget, observerConfig);
        }
    } catch (err) {
        console.error("Failed to load Funnelback search client (fbjs) for webinars-events:", err);
    }
};

initWebinarsEventsSearch();
